
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.095 15.97L16 15.675l-.095.293-.539 1.659h-2.051l.249.18 1.41 1.025-.539 1.659-.095.292.25-.18L16 19.577l1.41 1.025.25.181-.095-.292-.54-1.659 1.411-1.025.25-.18h-2.052l-.539-1.659z","fill":"#DBA514","stroke":"#A07500","stroke-width":".2"}}),_c('path',{attrs:{"d":"M4.75 12.792h9.5v-1.584h-9.5v1.584zM2.375 7.25v1.583h14.25V7.25H2.375zm5.542 9.5h3.166v-1.583H7.917v1.583z","fill":"#0867B7"}})])
          )
        }
      }
    